var alphabets = 'abcdefghijklmnopqrstuvwxyz'.split('');
var ResultsManager = /** @class */ (function () {
    function ResultsManager() {
    }
    /**
     * Appends new result into array of results, and calculates proper score_threshold for the newly added item
     */
    ResultsManager.prototype.appendNewResult = function (results, newResult) {
        results.unshift(newResult);
        results = this.recalculateScoreThresholds(results);
        results = this.recalculateIdentifiers(results);
        return results;
    };
    /**
     * Recalculates & assigns new identifiers to each of the results of the currently selected form.
     * Highest threshold should always be 'A', and lowest one whatever is the alphabet furthest down the range from 'A'.
     */
    ResultsManager.prototype.recalculateIdentifiers = function (results) {
        return results.map(function (result, index) {
            result.identifier = alphabets[results.length - index - 1].toUpperCase();
            return result;
        });
    };
    /**
     * Updates the score thresholds so that all thresholds are split evenly within the array
     */
    ResultsManager.prototype.recalculateScoreThresholds = function (results) {
        return results.map(function (result, index) {
            result.scoreThreshold = (index + 1) * (1 / results.length);
            return result;
        });
    };
    return ResultsManager;
}());
export default ResultsManager;
